<app-loader *ngIf="loader"></app-loader>
<div class="row" *ngIf="monthWiseHealthHistoryList.length !== 0">
    <div class="col-12">
        <div class="card main_card">
            <div class="card-body">
                <p>Previous Weekly Health History</p>
                <div class="accordion" [attr.id]="'accordion_' + i" *ngFor="let data of monthWiseHealthHistoryList; let i = index">
                    <div class="card-body p-0">
                        <div class="card-head" id="headingTwo">
                            <h2 class="mb-0 collapsed font-weight-bold indent" data-toggle="collapse" [attr.data-parent]="'#accordion_' + i" [attr.href]="'#collapseOne_' + i">
                                <div class="row">
                                    <div class="col-4 d-flex align-items-center">
                                        {{ data.month }}
                                    </div>
                                    <!-- <div class="col-4 d-flex align-items-center">Aug 2020</div> -->
                                    <div class="col-8 d-flex justify-content-center align-items-center week_img">
                                        <img src="../../../../../assets/img/healthRight.svg" alt="healthRight" class="img-fluid" *ngIf="data.status === 'HEALTHY'" />
                                        <img src="../../../../../assets/img/healthDanger.svg" alt="healthRight" class="img-fluid" *ngIf="data.status === 'UNHEALTHY'" />
                                        <img src="../../../../../assets/img/healthWarning.svg" alt="healthRight" class="img-fluid" *ngIf="data.status === 'CRITICAL'" />
                                        <img src="../../../../../assets/img/healthUndefined.svg" alt="healthRight" class="img-fluid" *ngIf="data.status === 'UNKNOWN'" />
                                    </div>
                                </div>
                            </h2>
                        </div>
                        <div [attr.id]="'collapseOne_' + i" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
                            <div class="card-body p-0" *ngFor="let diagnosis of data.diagnosis; let i = index">
                                <div class="row mt-4 mt-md-5 details">
                                    <div class="col-6">
                                        <p class="details_1">
                                            {{ diagnosis.created | date: "short" }}
                                        </p>
                                    </div>
                                    <div class="col-6">
                                        <button class="btn details_2 button_success" *ngIf="diagnosis.status == 'HEALTHY'">
                      <img
                        src="../../../../../assets/img/healthRight.svg"
                        alt="healthRight"
                        class="img-fluid"
                      />
                      Healthy
                    </button>
                                        <button class="btn details_2 button_unknow" *ngIf="diagnosis.status == 'UNKNOWN'">
                      <img
                        src="../../../../../assets/img/healthUndefined.svg"
                        alt="healthRight"
                        class="img-fluid"
                      />
                      Unknown
                    </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <button class="btn w-50 d-block ml-auto mr-auto mt-5 diagnos_btn" (click)="diagnose()">
          Diagnos Now!
        </button>
            </div>
        </div>
    </div>
</div>

<div class="row" *ngIf="monthWiseHealthHistoryList.length === 0">
    <div class="col-12">
        <div class="card nohealth_card">
            <div class="card-body">
                <img src="../../../../../assets/img/noHealth.png" alt="No Health" class="img-fluid d-block m-auto" />

                <button class="btn w-50 d-block ml-auto mr-auto mt-5 diagnos_btn" (click)="diagnose()">
          Diagnos Now!
        </button>
            </div>
        </div>
    </div>
</div>